export default "__VITE_ASSET__0537d055__"